import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from "@azure/msal-react";
import { ChakraProvider, Spinner } from "@chakra-ui/react";
import Head from "next/head";
import { useRouter } from "next/router";
import "react-day-picker/dist/style.css";
import 'react-quill/dist/quill.snow.css';
import { theme } from "../../styles/theme";
import './styles.css';

import { useEffect, useState } from "react";
import { Layout, LayoutDocumentation } from "../components/layout";
import AuthLoader from "../components/loading/AuthLoader";
import { APIProvider } from "../contexts/useAPI";
import { UserProvider } from "../contexts/useUser";
import { msalInstance } from "../services/authConfig";

function App({ Component, pageProps }) {

  const router = useRouter();
  const isDocumentation = router.pathname === '/documentation/[...path]';
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // We have to await for MicroSoft Authentication Library to load all its settings
    // before we can check if the user is currently logged in or not.
    msalInstance.initialize().then(() => {
      setIsInitialized(true);
    });
  }, [])


  useEffect(() => {
    const updateHtmlClass = () => {
      const htmlEl = document.documentElement;
      if (router.pathname === '/documentation/[...path]') {
        htmlEl.classList.add('documentation');
      } else {
        htmlEl.classList.remove('documentation');
      }
    };

    updateHtmlClass();
    const handleRouteChange = () => {
      updateHtmlClass();
    };

    router.events.on('routeChangeComplete', handleRouteChange);

    const observer = () => updateHtmlClass();
    window.addEventListener('popstate', observer);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
      window.removeEventListener('popstate', observer);
    };
  }, [router.pathname]);

  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
      <ChakraProvider theme={theme}>
        {isInitialized ?
          <MsalProvider instance={msalInstance}>
            <AuthenticatedTemplate>
              <APIProvider>
                <UserProvider>
                  {isDocumentation ?
                    <LayoutDocumentation>
                      <Component {...pageProps} />
                    </LayoutDocumentation>
                    :
                    <Layout>
                      <Component {...pageProps} />
                    </Layout>
                  }
                </UserProvider>
              </APIProvider>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
              <AuthLoader />
            </UnauthenticatedTemplate>
          </MsalProvider> :
          <Spinner style={{ position: 'fixed', top: '50%', left: '50%' }} size="lg" color="red" />}
      </ChakraProvider>
    </>
  )
}

export default App;